<template>
  <footer class="app-footer">
    <div class="footer-content">
        <div class="copyright">
            &copy; {{ currentYear }} BiblePlanGenerator.com
        </div>
        <div class="footer-links">
            <router-link to="/terms">Terms of Service</router-link>
            <router-link to="/privacy">Privacy Policy</router-link>
            <router-link to="/disclaimer">Disclaimer</router-link>
            <router-link to="/login">Login</router-link>
            <router-link to="/profile">Profile</router-link>
        </div>
    </div>
  </footer>
</template>

<script>
import { computed } from 'vue';

export default {
  name: 'TheFooter',
  setup() {
    const currentYear = computed(() => new Date().getFullYear());
    return { currentYear };
  }
}
</script>

<style scoped>
.app-footer {
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    padding: 30px 0;
    margin-top: 60px;
}

.footer-content {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
}

.copyright {
    color: #666;
    font-size: 0.9rem;
}

.footer-links {
    display: flex;
    gap: 24px;
}

.footer-links a {
    color: #888;
    text-decoration: none;
    font-size: 0.9rem;
    transition: color 0.2s;
}

.footer-links a:hover {
    color: #fff;
}

@media (max-width: 600px) {
    .footer-content {
        flex-direction: column;
        text-align: center;
    }
    .footer-links {
        flex-direction: column;
        gap: 12px;
    }
}
</style>
